import { useEffect } from 'react';

import {
  getPluginOAuthReturnPath,
  returnFromPluginOAuth,
} from '@coze-arch/bot-utils';

export function PluginAuthSuccess() {
  useEffect(() => {
    if (window.opener) {
      returnFromPluginOAuth();
    }
  }, []);

  return (
    <main className="min-h-screen flex flex-col items-center justify-center gap-[20px]">
      <h1 className="text-[24px] font-semibold">授权成功</h1>
      <p>已绑定当前工作台账号，可以继续使用插件。</p>
      <a className="text-blue-600" href={getPluginOAuthReturnPath()}>
        返回工作台
      </a>
    </main>
  );
}
